import { Action, withMatcher, createAction } from "utils/reducer/reducer.utils";

import { ACTIVITY_ACTION_TYPES } from "./activity.types";

export type FetchAllData = Action<ACTIVITY_ACTION_TYPES.FETCH_ALL_DATA>;

export const fetchAllActivities = withMatcher(
  (): FetchAllData => createAction(ACTIVITY_ACTION_TYPES.FETCH_ALL_DATA)
);
